module.exports = __webpack_public_path__ + "media/images/core_values/education-8c17e9eeb3dac27727d0164b09b61c8c.png";